import React, { Component } from 'react'
import { NavLink } from 'react-router-dom' 
import { FaHome, FaExclamationCircle } from 'react-icons/fa';
import { MdOutlineMiscellaneousServices, MdPermContactCalendar } from 'react-icons/md';
import { BsFillBagCheckFill } from 'react-icons/bs';
import myLogotipe from '../images/205080150_2916933228554539_687175735137985956_n.jpg'
import {FaListUl} from 'react-icons/fa'


export default class NavBarPortfolio extends Component {
  state = {
      classNav:null,
      togglrBtn:'toggleBnt',
  }
  classToglerBav = () => {
      if (this.state.classNav === null){
          this.setState({classNav:('aciveNav')})
          this.setState({togglrBtn:('toggleBnt toggleBntActive')})
      }else{
        this.setState({classNav:(null)})
        this.setState({togglrBtn:('toggleBnt')})
    }
  }
  render() {
    return (
        <nav className={this.state.classNav}>
            <NavLink className={'navBrend'} to={'/'}>
                <img src={myLogotipe} alt="" />
            </NavLink>
            <span onClick={this.classToglerBav} className={this.state.togglrBtn} >
                <FaListUl />
            </span>
            <ul>
                <li>
                    <NavLink to={'/'}>
                        <FaHome />
                        home
                    </NavLink>
                </li>
                <li>
                    <NavLink to={'/about'}>
                        <FaExclamationCircle />
                        about
                    </NavLink>
                </li>
                <li>
                    <NavLink to={'/services'}>
                        <MdOutlineMiscellaneousServices />
                        services
                    </NavLink>
                </li>
                <li>
                    <NavLink to={'/portfolio'}>
                        <BsFillBagCheckFill />
                        portfolio
                    </NavLink>
                </li>
                <li>
                    <NavLink to={'/contact'}>
                        <MdPermContactCalendar />
                        contact
                    </NavLink>
                </li>
            </ul>
        </nav>
    )
  }
}
